import { render } from "./UserTicketsView.vue?vue&type=template&id=f5bfe146&scoped=true"
import script from "./UserTicketsView.vue?vue&type=script&lang=js"
export * from "./UserTicketsView.vue?vue&type=script&lang=js"

import "./UserTicketsView.vue?vue&type=style&index=0&id=f5bfe146&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/tribuk-ui/tribuk-ui/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f5bfe146"]])

export default __exports__